import { rest as API } from './rest';

const basePath = ({ customerUUID, ecosystemUUID }) =>
  `/v2/customers/${customerUUID}/ecosystems/${ecosystemUUID}/groups`;

export const getGroupsList = (params) => API.get(basePath(params)).then(({ data }) => data);

export const getGroupDetail = (params) => API.get(`${basePath(params)}/${params.uuid}`).then(({ data }) => data);

export const createGroup = (params) => API.post(basePath(params), params.payload).then(({ data }) => data);

export const updateGroup = (params) =>
  API.put(`${basePath(params)}/${params.uuid}`, params.payload).then(({ data }) => data);

export const deleteGroup = (params) => API.delete(`${basePath(params)}/${params.uuid}`).then(({ data }) => data);
